import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const StyledLabel = styled.span`
  position: relative;
  padding: 0.6rem 1.2rem;
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;

  span {
    position: relative;
    z-index: 20;
    color: ${(props) => props.theme.colors.white};
    font-family: ${(props) => props.theme.fontStacks.heading};
    letter-spacing: 0.06rem;
    font-size: 1.4rem;
  }
`

function Label({ children, element, ...props }) {
  return (
    <StyledLabel as={element} {...props}>
      {children}
    </StyledLabel>
  )
}

export default Label

Label.defaultProps = {}
Label.propTypes = {
  children: PropTypes.node.isRequired,
  element: PropTypes.string,
}
